export const FETCH_COLLECTIONS_REQUEST = 'FETCH_COLLECTIONS_REQUEST';
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_FAILURE = 'FETCH_COLLECTIONS_FAILURE';

export const ADD_COLLECTION_REQUEST = 'ADD_COLLECTION_REQUEST';
export const ADD_COLLECTION_SUCCESS = 'ADD_COLLECTION_SUCCESS';
export const ADD_COLLECTION_FAILURE = 'ADD_COLLECTION_FAILURE';

export const UPDATE_COLLECTION_REQUEST = 'UPDATE_COLLECTION_REQUEST';
export const UPDATE_COLLECTION_SUCCESS = 'UPDATE_COLLECTION_SUCCESS';
export const UPDATE_COLLECTION_FAILURE = 'UPDATE_COLLECTION_FAILURE';

export const DELETE_COLLECTION_REQUEST = 'DELETE_COLLECTION_REQUEST';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_FAILURE = 'DELETE_COLLECTION_FAILURE';

export const SET_COLLECTION_EDIT = 'SET_COLLECTION_EDIT';
export const CLEAR_COLLECTION_EDIT = 'CLEAR_COLLECTION_EDIT'; 